import React from 'react';
import styles from './style.module.scss';
import CaretDown24 from '../../../../../../../../assets/svg/icons/common/CaretDown24';
import CheckGreenCircleIcon from '../../../../../../../../assets/svg/icons/common/check-green-circle';

const ReviewHeader = ({ title, isOpen, onToggle, onEdit }) => {
  return (
    <div className={styles.header} onClick={onToggle}>
      <div className={styles.header_left}>
        <CaretDown24 data-open={String(isOpen)} />
        <h6 className={styles.title}>{title}</h6>
      </div>
      {onEdit && (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <button 
          className={styles.editButton} 
          onClick={(e) => {
            e.stopPropagation();
            onEdit();
          }}
        >
          Edit
        </button>
          <CheckGreenCircleIcon />
        </div>
      )}
    </div>
  );
};

export default ReviewHeader; 